// @flow

import type {AuthBloc} from "../../blocs/authBloc";
import {apiAxios} from '../../config/AxiosConfig'
import {CreateInKindDonationRequest, UpdateInKindDonationRequest} from "../../models/InKindDonation/InKindDonation";
import { AppToaster } from '../../components/Toaster/Toaster';
import { Intent } from '@blueprintjs/core';


class DonationApi {

    authBloc : AuthBloc;

    constructor(authBloc: AuthBloc) {
        this.authBloc = authBloc;
    }

    async createDonation(createDonationRequest: CreateInKindDonationRequest) : Promise<any> {
        const tenantId = this.authBloc.getCurrentTenant();

        let payload;
        if(createDonationRequest.attachment){
            payload = createDonationRequest.attachment.payload;
            delete createDonationRequest.attachment.payload;
        }

        const response = await apiAxios.post(`/tenants/${tenantId}/projects/${createDonationRequest.projectId}/donations`, createDonationRequest, this.buildHeaders());

        if(createDonationRequest.attachment)
            createDonationRequest.attachment.payload = payload;

        if (response.status === 201) {
            AppToaster.show({
                message: "In-Kind Donation Created",
                intent: Intent.PRIMARY,
              });
            return response.data;
        } else {
            throw new Error(response.status);
        }
    }

    async updateDonation(updateDonationRequest: UpdateInKindDonationRequest) : Promise<any> {
        const tenantId = this.authBloc.getCurrentTenant();

        let payload;
        if(updateDonationRequest.attachment){
            payload = updateDonationRequest.attachment.payload;
            delete updateDonationRequest.attachment.payload;
        }

        const response = await apiAxios.patch(
            `/tenants/${tenantId}/projects/${updateDonationRequest.projectId}/donations/${updateDonationRequest.donationId}`,
            updateDonationRequest,
            this.buildHeaders()
        );

        if(updateDonationRequest.attachment)
            updateDonationRequest.attachment.payload = payload;

        if (response.status === 201) {
            AppToaster.show({
                message: "In-Kind Donation Updated",
                intent: Intent.PRIMARY,
              });
            return response.data;
        } else {
            throw new Error(response.status);
        }
    }

    async deleteDonation(projectId: string, donationId: string) : Promise<void> {
        const tenantId = this.authBloc.getCurrentTenant();

        const response = await apiAxios.delete(
            `/tenants/${tenantId}/projects/${projectId}/donations/${donationId}`,
            this.buildHeaders()
        );

        if (response.status === 200) {
            AppToaster.show({
                message: "In-Kind Donation Deleted",
                intent: Intent.PRIMARY,
              });
            return response.data;
        } else {
            throw new Error(response.status);
        }
    }

    buildHeaders = ()=> {
        const accessToken = this.authBloc.getCurrentToken();
        const auth = "Bearer " + accessToken;
        return {headers:{Authorization:auth}};
    }
}

export default DonationApi;
